import React, { useState } from 'react';
import { repoDisplayName } from '../../lib/linkDisplay.js';
import { RepoGlyph } from './LinkGlyphs.jsx';

function TechPill({ name, percent }) {
  return (
    <span
      className="inline-flex items-center gap-1 text-[11px] px-2 py-0.5 rounded-full"
      style={{ background: '#F2F1ED', color: '#3A3A38' }}
    >
      <span style={{ color: '#1A1A1A', fontWeight: 500 }}>{name}</span>
      <span style={{ color: '#6B6B68' }}>{Number(percent).toFixed(1)}%</span>
    </span>
  );
}

async function deleteRepo(id) {
  const res = await fetch(`/repositories/${id}`, {
    method:      'DELETE',
    credentials: 'same-origin',
    headers: {
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || '',
      'Accept':       'application/json'
    }
  });
  if (res.status === 401) { window.location = '/session/new'; return false; }
  if (res.status === 403) {
    window.alert("You don't have permission — only a project manager can delete this repository.");
    return false;
  }
  if (!res.ok && res.status !== 204) throw new Error(`DELETE failed (${res.status})`);
  return true;
}

export default function RepoItem({ repo, dividerTop, onDeleted }) {
  const [hover, setHover] = useState(false);
  const [busy, setBusy]   = useState(false);
  const stack = repo.tech_stack || [];
  const name  = repo.title && repo.title.trim() ? repo.title.trim() : repoDisplayName(repo.url);

  async function destroy(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!window.confirm('Delete this repository?')) return;
    setBusy(true);
    try {
      const ok = await deleteRepo(repo.id);
      if (ok) onDeleted(repo.id);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{ paddingTop: dividerTop ? 12 : 0, marginTop: dividerTop ? 12 : 0, borderTop: dividerTop ? '1px solid #F0EFE9' : 'none' }}
    >
      <div className="flex items-center justify-between gap-2">
        <span className="flex items-center gap-2 min-w-0">
          <span style={{ color: '#8A897F', display: 'inline-flex', flexShrink: 0 }}><RepoGlyph /></span>
          <a
            href={repo.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[13px] font-mono break-all underline"
            style={{ color: '#1A1A1A' }}
          >
            {name}
          </a>
        </span>
        <button
          type="button"
          onClick={destroy}
          aria-label={`Delete ${name}`}
          style={{
            background: 'none', border: 'none', color: '#9B1F26',
            fontSize: 11, cursor: 'pointer', padding: '2px 6px', flexShrink: 0,
            visibility: (hover && !busy) ? 'visible' : 'hidden'
          }}
        >Delete</button>
      </div>
      {stack.length > 0 && (
        <>
          <div className="text-[11px] uppercase tracking-wider mt-3 mb-1.5" style={{ color: '#9A9A95', letterSpacing: '0.08em' }}>
            Tech stack
          </div>
          <div className="flex flex-wrap gap-1.5">
            {stack.map((t, i) => <TechPill key={`${t.name}-${i}`} name={t.name} percent={t.percent} />)}
          </div>
        </>
      )}
    </div>
  );
}
